import { useState } from "react";
import { CssBaseline } from "@mui/material";
import AppMenu from "./navigation/side/AppMenu";
import AppBar from "./navigation/top/AppBar";
import ViewSnackbar from "./viewComponents/ViewSnackbar";

/**
 * The main application layout component, which renders both side menu and top bar.
 *
 * @returns the application main layout component
 */
const AppLayout = () => {
	const [menuIsOpen, setMenuIsOpen] = useState<boolean>(true);

	const openMenu = () => {
		setMenuIsOpen(true);
	};

	const closeMenu = () => {
		setMenuIsOpen(false);
	};

	return (
		<>
			<CssBaseline />
			<AppBar menuIsOpen={menuIsOpen} openMenu={openMenu} />
			<AppMenu menuIsOpen={menuIsOpen} closeMenu={closeMenu} />
			<ViewSnackbar />
		</>
	);
};

export default AppLayout;
